import { mutate } from 'swr';
import { getCacheKey } from 'utils/getCacheKey';

export const mutateProject = (projectId: string) => {
  const searchedKey = getCacheKey('/projects/' + projectId);
  if (searchedKey) {
    mutate(searchedKey);
  }
};
